<script setup lang="ts">
import FooterItem from '@fondof-ui/components/footer/FooterItem.vue'
import FooterSocialLink from '@fondof-ui/components/footer/FooterSocialLink.vue'
import type { FooterSocialLinkItem } from '@fondof-ui/types'
import FooterHeadline from '@satch-ui/components/footer/FooterHeadline.vue'
import { t } from '@satch-ui/translations/translations'

const props = defineProps<{ socials: FooterSocialLinkItem[] }>()
</script>
<template>
  <div class="row-start-5 md:col-start-[second-col] md:row-start-[third-row]">
    <FooterItem disabled>
      <template #headline="{ disabled }">
        <FooterHeadline
          :headline="t('footer.socialTitle')"
          variant="primary"
          :disabled="disabled"
        />
      </template>
      <template #content>
        <div class="flex space-x-2">
          <FooterSocialLink
            v-for="link in props.socials"
            :key="link.name"
            :link="link"
            class="hover:!bg-primary [&>a]:!text-black [&>a]:hover:!text-white"
          />
        </div>
      </template>
    </FooterItem>
  </div>
</template>
